"use client";
import React from "react";
import Block from "./webflow_modules/Basic/components/Block";

export function RegionalPageApartmentCount({
  numberOfApartmentsText = "# Apartments in Market",
}) {
  return (
    <Block tag={"div"}>
      <Block className={"regional-page-of-apartments-container"} tag={"div"}>
        <Block className={"heading-style-h6 text-color-blue"} tag={"div"}>
          {numberOfApartmentsText}
        </Block>
      </Block>
    </Block>
  );
}
